import { render } from "./ClientUpdatePhoto.vue?vue&type=template&id=6c0f89e2&scoped=true"
import script from "./ClientUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./ClientUpdatePhoto.vue?vue&type=script&lang=js"

import "./ClientUpdatePhoto.vue?vue&type=style&index=0&id=6c0f89e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0f89e2"]])

export default __exports__